// STEP STUDIO-OVERLAY-DRAG-RESIZE-1 · Overlay 자유 배치 공통 상수/유틸 (Studio · 소비자 · Egress 공용).
//   rect = { cx, cy, w } · cx/cy = 무대 기준 중심 (0~1) · w = 무대 폭 비율.
export const LAYOUT_ELEMENTS = ['card', 'qr', 'size_table', 'notice_image', 'past_card', 'combined_horizontal', 'combined_vertical',
  'combined_mini_horizontal', 'combined_mini_vertical', 'timer', 'notice'];
export const ELEMENT_LABELS = { card: '상품 카드', qr: 'QR 코드', size_table: '상품설명', notice_image: '공지 이미지', past_card: '지난 상품',
  combined_horizontal: '통합 카드', combined_vertical: '통합 카드', combined_mini_horizontal: '통합 미니', combined_mini_vertical: '통합 미니', timer: '타이머',
  notice: '공지 문구' };

// 콘텐츠 기준 폭 (무대 폭 비율) — 이 폭으로 렌더 후 rect.w / base 로 확대·축소.
export const BASE_FRAC = {
  '9:16': { card_horizontal: 0.84, card_vertical: 0.46, qr: 0.3, size_table: 0.7, notice_image: 0.5, past_card_horizontal: 0.5, past_card_vertical: 0.3, combined_horizontal: 0.9, combined_vertical: 0.42, combined_mini_horizontal: 0.72, combined_mini_vertical: 0.3, timer: 0.3, notice: 0.9 },
  '16:9': { card_horizontal: 0.4, card_vertical: 0.2, qr: 0.14, size_table: 0.4, notice_image: 0.28, past_card_horizontal: 0.24, past_card_vertical: 0.14, combined_horizontal: 0.46, combined_vertical: 0.2, combined_mini_horizontal: 0.3, combined_mini_vertical: 0.12, timer: 0.12, notice: 0.6 },
};

export const MIN_W = {
  '9:16': { card_horizontal: 0.45, card_vertical: 0.34, qr: 0.2, size_table: 0.5, notice_image: 0.15, past_card_horizontal: 0.34, past_card_vertical: 0.22, combined_horizontal: 0.6, combined_vertical: 0.3, combined_mini_horizontal: 0.45, combined_mini_vertical: 0.24, timer: 0.2, notice: 0.5 },
  '16:9': { card_horizontal: 0.22, card_vertical: 0.14, qr: 0.1, size_table: 0.3, notice_image: 0.08, past_card_horizontal: 0.14, past_card_vertical: 0.09, combined_horizontal: 0.32, combined_vertical: 0.14, combined_mini_horizontal: 0.22, combined_mini_vertical: 0.1, timer: 0.08, notice: 0.2 },
};

// 기본 위치 — 상품 카드는 화면 중앙.
export const DEFAULT_RECTS = {
  '9:16': {
    card: { cx: 0.5, cy: 0.5, w: 0.84 },
    qr: { cx: 0.78, cy: 0.62, w: 0.3 },
    size_table: { cx: 0.5, cy: 0.3, w: 0.7 },
    notice_image: { cx: 0.3, cy: 0.27, w: 0.4 },
    timer: { cx: 0.67, cy: 0.4, w: 0.3 },
    // STUDIO-NOTICE-TIMER-LAYOUT-FIX-1 · 공지 문구 기본 (배치 편집 툴바 아래 · 잡을 수 있는 위치).
    notice: { cx: 0.5, cy: 0.31, w: 0.9 },
    past_card: { cx: 0.27, cy: 0.4, w: 0.46 },
    // COMBINED-CARD-DESIGN-FIX-1 · 컴팩트 기본값 (저장값 없을 때·기본 위치 복원 시만) — 우측 버튼줄(y<0.47)·하단 버튼(y>0.9) 회피.
    combined_horizontal: { cx: 0.5, cy: 0.79, w: 0.9 },
    combined_vertical: { cx: 0.25, cy: 0.62, w: 0.42 },
    combined_mini_horizontal: { cx: 0.4, cy: 0.81, w: 0.72 },
    combined_mini_vertical: { cx: 0.19, cy: 0.66, w: 0.3 },
  },
  '16:9': {
    card: { cx: 0.5, cy: 0.5, w: 0.4 },
    qr: { cx: 0.88, cy: 0.7, w: 0.14 },
    size_table: { cx: 0.5, cy: 0.45, w: 0.4 },
    notice_image: { cx: 0.5, cy: 0.18, w: 0.28 },
    timer: { cx: 0.9, cy: 0.5, w: 0.12 },
    notice: { cx: 0.155, cy: 0.3, w: 0.25 },
    past_card: { cx: 0.15, cy: 0.5, w: 0.24 },
    combined_horizontal: { cx: 0.3, cy: 0.82, w: 0.46 },
    combined_vertical: { cx: 0.12, cy: 0.55, w: 0.2 },
    combined_mini_horizontal: { cx: 0.2, cy: 0.85, w: 0.3 },
    combined_mini_vertical: { cx: 0.08, cy: 0.6, w: 0.12 },
  },
};

// STEP STUDIO-OVERLAY-COMBINED-PRESET-1 · 표시 설정 top-level 키 (명시적 OFF 보존).
export const TOP_KEYS = ['display_mode', 'combined_orientation', 'combined_items', 'preset'];
export const displayMode = (layout) => (layout?.display_mode === 'combined' ? 'combined' : 'separate');
export const combinedOrientation = (layout) => (layout?.combined_orientation === 'vertical' ? 'vertical' : 'horizontal');
export const combinedItems = (layout) => ({ size_table: false, qr: false, ...(layout?.combined_items || {}) });
// backend effective_layout 과 동일 — 판매자 기본 위에 방송별 명시 저장분 덮어쓰기.
export const mergeLayout = (def, own) => {
  const o = own && typeof own === 'object' ? own : {};
  const keep = Object.fromEntries(Object.entries(o).filter(([k, v]) => v || (TOP_KEYS.includes(k) && v != null)));
  const m = { ...(def && typeof def === 'object' ? def : {}), ...keep };
  return Object.keys(m).length ? m : null;
};

const NOTICE_SIZE_W = { small: 0.3, medium: 0.5, large: 0.75 };

// 동시 표시 기본 위치 (저장값 없을 때만) — 9:16 상단 상태영역(~12%) · 우측 버튼줄(x>0.84, y<0.47) · 하단 버튼(y>0.9) 회피.
const COMBO_RECTS = {
  '9:16': {
    horizontal: { card: { cx: 0.5, cy: 0.78 }, qr: { cx: 0.8, cy: 0.58, w: 0.26 }, size_table: { cx: 0.45, cy: 0.22, w: 0.62 }, notice_image: { cx: 0.7, cy: 0.42, w: 0.26 } },
    vertical: { card: { cx: 0.46, cy: 0.74 }, qr: { cx: 0.82, cy: 0.64, w: 0.26 }, size_table: { cx: 0.45, cy: 0.22, w: 0.62 }, notice_image: { cx: 0.7, cy: 0.42, w: 0.26 } },
  },
  '16:9': {
    horizontal: { card: { cx: 0.3, cy: 0.82 } },
    vertical: { card: { cx: 0.15, cy: 0.62 } },
  },
};
// 지난 상품 기본 위치 — 자체 가로/세로 형태 기준 (현재 상품 카드와 독립).
const PAST_RECTS = {
  '9:16': { horizontal: { cx: 0.27, cy: 0.4, w: 0.46 }, vertical: { cx: 0.2, cy: 0.3, w: 0.3 } },
  '16:9': { horizontal: { cx: 0.15, cy: 0.5, w: 0.24 }, vertical: { cx: 0.1, cy: 0.45, w: 0.14 } },
};
const PAST_COMBO = {
  '9:16': { horizontal: { cx: 0.27, cy: 0.5, w: 0.46 }, vertical: { cx: 0.2, cy: 0.5, w: 0.28 } },
  '16:9': PAST_RECTS['16:9'],
};

export const orientKey = (isPortrait) => (isPortrait ? '9:16' : '16:9');
export const cardOrientation = (layout) => (layout?.card_orientation === 'vertical' ? 'vertical' : 'horizontal');
export const pastOrientation = (layout) => (layout?.past_card_orientation === 'vertical' ? 'vertical' : 'horizontal');
export const elKey = (el, layout) => (el === 'card' ? `card_${cardOrientation(layout)}`
  : el === 'past_card' ? `past_card_${pastOrientation(layout)}` : el);
export const baseFrac = (orient, el, layout) => BASE_FRAC[orient]?.[elKey(el, layout)] || 0.5;
export const minW = (orient, el, layout) => MIN_W[orient]?.[elKey(el, layout)] || 0.1;
// 세로형 카드는 실제 폭 렌더(fluid) 로 내부 반응형 적용.
export const isFluid = (el, layout) => (el === 'card' && cardOrientation(layout) === 'vertical')
  || el === 'past_card' || el.startsWith('combined_');
export const getRect = (layout, orient, el) => {
  const r = layout?.[orient]?.[el];
  return r && Number.isFinite(r.cx) && Number.isFinite(r.cy) && Number.isFinite(r.w) ? r : null;
};

// 편집 시작 시 초기 rect (저장값 → 기본값 · 공지 이미지는 기존 소·중·대 크기 반영).
export const initialRect = (layout, orient, el, { noticeSize, combo, preLive } = {}) => {
  const saved = getRect(layout, orient, el);
  if (saved) return saved;
  const d = el === 'past_card'
    ? { ...(combo ? PAST_COMBO : PAST_RECTS)[orient][pastOrientation(layout)] }
    : { ...DEFAULT_RECTS[orient][el], ...(combo ? COMBO_RECTS[orient][cardOrientation(layout)][el] : {}) };
  if (el === 'card') d.w = baseFrac(orient, 'card', layout);
  if (el === 'notice_image' && !combo && orient === '9:16' && NOTICE_SIZE_W[noticeSize]) d.w = NOTICE_SIZE_W[noticeSize];
  // 방송 전(9:16): 하단 준비 버튼(마이크 선택·화면 프리셋·LIVE 시작, y>~0.7) 위로 기본값만 올림.
  if (preLive && orient === '9:16' && d.cy > 0.55) d.cy = Math.max(0.3, d.cy - 0.24);
  return d;
};

// 화면 밖 이탈 방지 — 폭 절반만큼 좌우 여백 확보 · 세로는 4% 여백.
export const clampRect = (r, orient, el, layout) => {
  const w = Math.min(1, Math.max(minW(orient, el, layout), r.w));
  const half = Math.min(0.5, w / 2);
  return {
    cx: Math.min(1 - half, Math.max(half, r.cx)),
    cy: Math.min(0.96, Math.max(0.04, r.cy)),
    w,
  };
};
